
import jsonQuery from 'json-query'
import _ from 'lodash'
import { Component, createRef } from 'react'

import { USStateCodes, ContactPointCodes, Nucc } from '../../../../../../lib/Codes'
import { capitalizeSentence } from '../../../../../../lib/Form'
import {
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  Collection,
  Fieldset,
  getOrEmpty,
  IconCheckInput,
  mapCodeForSelect,
  MaskedTextInput,
  NPIPractitionerAutoCompleteSelect,
  preferredUpdate,
  SaveButton,
  SelectInput,
  AutoCompleteInput,
  TextInput,
  ToggleInput,
  Validators
} from '../../../../../shared/FormBuilder'
import { Paper, RequiredSpan } from '../../../../../shared/NarusMaterial'

class MedicalTeamForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)

    this.npiPractitionerName = createRef()
  }

  getValue = () => ({ ...this.state.value })

  componentDidMount () {
    const value = this.getValue()
    value.phones = getOrEmpty(value.phones)
    value.faxes = getOrEmpty(value.faxes)
    value.emails = getOrEmpty(value.emails)
    this.setState({
      isSubmitting: false,
      value
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { value } = this.state
    if (value.phones && value.phones.length > 1) {
      preferredUpdate(
        prevState.value.phones,
        this.state.value.phones,
        this.state.value,
        this,
        'phones'
      )
    }
    if (value.emails && value.emails.length > 1) {
      preferredUpdate(
        prevState.value.emails,
        this.state.value.emails,
        this.state.value,
        this,
        'emails'
      )
    }
    if (value.faxes && value.faxes.length > 1) {
      preferredUpdate(
        prevState.value.faxes,
        this.state.value.faxes,
        this.state.value,
        this,
        'faxes'
      )
    }
  }

  fullName = () => {
    const v = this.getValue()
    const first = _.capitalize(_.get(v, 'firstName'))
    const last = _.capitalize(_.get(v, 'lastName'))
    return [ last, first ].join(', ')
  }

  isNewEntry = () => _.isNil(this.state.value.id)

  UNSAFE_componentWillMount () {
    if (this.isNewEntry()) {
      /* eslint-disable */
      let newEntry = this.state.value;
      /* eslint-enable */
      newEntry.pcp = false
      this.setState({ value: newEntry })
    }
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  handlePractitionerSelect = practitioner => {
    const jq = jsonQuery
    const q = query => jq(query, { data: practitioner }).value

    const { emails } = this.state.value

    const queryPhones = q('telecom[*system=phone]') || []
    const queryFaxes = q('telecom[*system=fax]') || []

    const phoneTypes = ContactPointCodes.contactPointUse.map(c => c.code)

    const newPhones = queryPhones
      .filter(p => _.includes(phoneTypes, p.use))
      .map(p => ({
        preferred: false,
        phoneType: p.use,
        number: p.value
      }))

    const newFaxes = queryFaxes
      .filter(p => _.includes(phoneTypes, p.use))
      .map(p => ({
        preferred: false,
        faxType: p.use,
        number: p.value
      }))

    const zip = q('address[0].postalCode')

    this.setInputValue('.npi', _.capitalize(q('id')))
    this.setInputValue('.lastName', _.capitalize(q('name[0].family')))
    this.setInputValue('.middleName', _.capitalize(q('name[0].given[1]')))
    this.setInputValue('.firstName', _.capitalize(q('name[0].given[0]')))
    this.setInputValue('.prefix', q('name[0].prefix[0]'))
    this.setInputValue('.suffix', q('name[0].suffix[0]'))
    this.setInputValue('.credentials', q('name[0].prefix[1]'))
    this.setInputValue('.specialty', q('qualification[0].code.coding[0].code'))
    this.setInputValue(
      '.address1',
      capitalizeSentence(q('address[0].line[0]'))
    )
    this.setInputValue(
      '.address2',
      capitalizeSentence(q('address[0].line[1]'))
    )
    this.setInputValue('.city', capitalizeSentence(q('address[0].city')))
    this.setInputValue('.state', q('address[0].state'))
    this.setInputValue('.zip', zip ? zip.substr(0, 5) : undefined)
    this.setInputValue('.phones', getOrEmpty(newPhones))
    this.setInputValue('.faxes', getOrEmpty(newFaxes))
    this.setInputValue('.emails', getOrEmpty(emails))
  }

  render () {
    const state = this.getValue()
    const { onCancel } = this.props
    const { id, lastName, npi } = state

    const isNewRecord = _.isNil(id)
    const disableSave = _.isEmpty(lastName)

    return (
      <div className='form-section'>
        {isNewRecord
          ? (
            <div className='nh-margin-bottom-2'>
              <Paper>
                <h2>NPI Registry Search</h2>

                <NPIPractitionerAutoCompleteSelect
                  ref={this.npiPractitionerName}
                  onChange={this.handlePractitionerSelect}
                  label='Search Provider'
                />

              </Paper>
            </div>
          )
          : null}
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-2'>
              <TextInput
                disabled={npi && npi.length > 0}
                label='Prefix'
                name='prefix'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                disabled={npi && npi.length > 0}
                label='First Name'
                name='firstName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-2'>
              <TextInput
                disabled={npi && npi.length > 0}
                label='Middle Name'
                name='middleName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <div>
                <TextInput
                  disabled={npi && npi.length > 0}
                  label='Last Name'
                  name='lastName'
                />
                <RequiredSpan />
              </div>
            </div>

            <div className='col-xs-12 col-sm-6 col-md-2'>
              <TextInput
                disabled={npi && npi.length > 0}
                label='Suffix'
                name='suffix'
              />
            </div>

            <div className='col-xs-12 col-sm-3 col-md-2'>
              <TextInput
                label='NPI ID'
                name='npi'
                disabled
              />
            </div>

            <div className='col-xs-12 col-sm-3 col-md-2'>
              <TextInput
                disabled={npi && npi.length > 0}
                label='Credentials'
                name='credentials'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-8'>
              <AutoCompleteInput
                label='Specialty'
                name='specialty'
                options={mapCodeForSelect(Nucc)}
              />
            </div>
          </div>

          <div className='row middle-xs'>
            <div className='col-xs-12 col-sm-8'>
              <TextInput
                label='Practice Name'
                name='practiceName'
              />
            </div>

            <div className='col-xs-12 col-sm-4'>
              <CheckboxInput
                disabled={this.props.noPCP}
                label='Primary Care Provider'
                name='pcp'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12 nh-no-wrap'>
              <ToggleInput
                label='Authorization to speak with provider'
                name='authorization'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 1'
                name='address1'
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 2'
                name='address2'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='City'
                name='city'
              />
            </div>

            <div className='bottom-xs col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                label='State'
                name='state'
                options={mapCodeForSelect(USStateCodes)}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <MaskedTextInput
                mask='11111'
                name='zip'
                label='Zip'
              />
            </div>
          </div>

          <div className='row'>
            <div
              className='col-md-12'
              style={{
                position: 'relative',
                top: '2em'
              }}
            >
              <h2>Phones</h2>
            </div>
          </div>

          <Collection name='phones'>
            <Fieldset>
              <div className='checkbox-wrapper'>
                <IconCheckInput
                  name='preferred'
                  checkedIcon='star'
                  uncheckedIcon='star-o'
                />
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-3 col-md-3'>
                  <SelectInput
                    name='phoneType'
                    label='Phone Type'
                    options={mapCodeForSelect(
                      ContactPointCodes.contactPointUse
                    )}
                  />
                </div>
                <div className='col-xs-12 col-sm-5 col-md-5'>
                  <MaskedTextInput
                    mask='111.111.1111'
                    name='number'
                    label='Phone Number'
                  />
                </div>
                <div className='col-xs-12 col-sm-4 col-md-4'>
                  <SelectInput
                    name='status'
                    label='Status'
                    noSort
                    options={ContactPointCodes.contactStatus}
                  />
                </div>
              </div>
            </Fieldset>
          </Collection>

          <div className='row'>
            <div
              className='col-md-12'
              style={{
                position: 'relative',
                top: '2em'
              }}
            >
              <h2>Faxes</h2>
            </div>
          </div>

          <Collection name='faxes'>
            <Fieldset>
              <div className='checkbox-wrapper'>
                <IconCheckInput
                  name='preferred'
                  checkedIcon='star'
                  uncheckedIcon='star-o'
                />
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-3 col-md-3'>
                  <SelectInput
                    name='faxType'
                    label='Fax Type'
                    options={mapCodeForSelect(
                      ContactPointCodes.contactPointUse
                    )}
                  />
                </div>
                <div className='col-xs-12 col-sm-5 col-md-5'>
                  <MaskedTextInput
                    mask='111.111.1111'
                    name='number'
                    label='Fax Number'
                  />
                </div>
                <div className='col-xs-12 col-sm-4 col-md-4'>
                  <SelectInput
                    name='status'
                    label='Status'
                    noSort
                    options={ContactPointCodes.contactStatus}
                  />
                </div>
              </div>
            </Fieldset>
          </Collection>

          <div className='row'>
            <div
              className='col-md-12'
              style={{
                position: 'relative',
                top: '2em'
              }}
            >
              <h2>Emails</h2>
            </div>
          </div>

          <Collection name='emails'>
            <Fieldset>
              <div className='checkbox-wrapper'>
                <IconCheckInput
                  name='preferred'
                  checkedIcon='star'
                  uncheckedIcon='star-o'
                />
              </div>
              <div className='row'>
                <div className='col-xs-12 col-sm-10 col-md-10'>
                  <TextInput
                    name='address'
                    label='Email'
                    validators={[ Validators.email() ]}
                  />
                </div>
              </div>
            </Fieldset>
          </Collection>

          <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <h2>Notes</h2>
            </div>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <TextInput
                label='Notes'
                name='notes'
              />
            </div>
          </div>

          <div
            className='row end-xs'
            style={{ marginTop: '20px' }}
          >
            <div className='col-xs-12'>
              <CancelButton
                noGlobal
                long
                onClick={onCancel}
              />
              <SaveButton
                long
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }
}

export default MedicalTeamForm
